import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2b2f4206 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _9e9008bc = () => interopDefault(import('..\\pages\\download\\index.vue' /* webpackChunkName: "pages/download/index" */))
const _dc24516e = () => interopDefault(import('..\\pages\\help\\index.vue' /* webpackChunkName: "pages/help/index" */))
const _030eba2a = () => interopDefault(import('..\\pages\\home\\index.vue' /* webpackChunkName: "pages/home/index" */))
const _03c88c77 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _0d14a95c = () => interopDefault(import('..\\pages\\notice\\index.vue' /* webpackChunkName: "pages/notice/index" */))
const _96efced6 = () => interopDefault(import('..\\pages\\noticesys\\index.vue' /* webpackChunkName: "pages/noticesys/index" */))
const _16202b8a = () => interopDefault(import('..\\pages\\serve\\index.vue' /* webpackChunkName: "pages/serve/index" */))
const _79c59e10 = () => interopDefault(import('..\\pages\\noticesys\\detail-sd.vue' /* webpackChunkName: "pages/noticesys/detail-sd" */))
const _54043906 = () => interopDefault(import('..\\pages\\wechat\\download.vue' /* webpackChunkName: "pages/wechat/download" */))
const _2a110fe6 = () => interopDefault(import('..\\pages\\news\\_guid.vue' /* webpackChunkName: "pages/news/_guid" */))
const _3eb6d230 = () => interopDefault(import('..\\pages\\notice\\_guid.vue' /* webpackChunkName: "pages/notice/_guid" */))
const _c891f7aa = () => interopDefault(import('..\\pages\\noticesys\\_guid.vue' /* webpackChunkName: "pages/noticesys/_guid" */))
const _4534d4aa = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _2b2f4206,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/download",
    component: _9e9008bc,
    alias: "/download/index.html",
    name: "download"
  }, {
    path: "/help",
    component: _dc24516e,
    alias: "/help/index.html",
    name: "help"
  }, {
    path: "/home",
    component: _030eba2a,
    alias: "/home/index.html",
    name: "home"
  }, {
    path: "/news",
    component: _03c88c77,
    alias: "/news/index.html",
    name: "news"
  }, {
    path: "/notice",
    component: _0d14a95c,
    alias: "/notice/index.html",
    name: "notice"
  }, {
    path: "/noticesys",
    component: _96efced6,
    alias: "/noticesys/index.html",
    name: "noticesys"
  }, {
    path: "/serve",
    component: _16202b8a,
    alias: "/serve/index.html",
    name: "serve"
  }, {
    path: "/noticesys/detail-sd",
    component: _79c59e10,
    alias: "/noticesys/detail-sd/index.html",
    name: "noticesys-detail-sd"
  }, {
    path: "/wechat/download",
    component: _54043906,
    alias: "/wechat/download/index.html",
    name: "wechat-download"
  }, {
    path: "/news/:guid",
    component: _2a110fe6,
    alias: "/news/:guid/index.html",
    name: "news-guid"
  }, {
    path: "/notice/:guid",
    component: _3eb6d230,
    alias: "/notice/:guid/index.html",
    name: "notice-guid"
  }, {
    path: "/noticesys/:guid",
    component: _c891f7aa,
    alias: "/noticesys/:guid/index.html",
    name: "noticesys-guid"
  }, {
    path: "/",
    component: _4534d4aa,
    alias: "/index.html",
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
